import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const rsvpSearchSchema = z.object({
  token: z.string().optional(),
  preview: z.union([z.literal('1'), z.string()]).optional(),
  event_uuid: z.string().optional(),
});

export type RsvpSearch = z.infer<typeof rsvpSearchSchema>;

export const Route = createFileRoute('/events/rsvp')({
  validateSearch: rsvpSearchSchema,
});
